<template>
  <!-- viewBox="0 0 16 16" -->
  <path
    d="M2 12V4C2 2.89543 2.89543 2 4 2H12C13.1046 2 14 2.89543 14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12Z"
    fill="#EF501E"
  />
  <path
    d="M3.83287 8.59066V10H3V6H4.5769C4.88044 6 5.14696 6.05495 5.37646 6.16484C5.60781 6.27473 5.78549 6.43132 5.90949 6.63462C6.0335 6.83608 6.0955 7.06593 6.0955 7.32418C6.0955 7.71612 5.95947 8.02564 5.6874 8.25275C5.41718 8.47802 5.04238 8.59066 4.56302 8.59066H3.83287ZM3.83287 7.92308H4.5769C4.79715 7.92308 4.96465 7.87179 5.0794 7.76923C5.196 7.66667 5.2543 7.52015 5.2543 7.32967C5.2543 7.1337 5.196 6.97527 5.0794 6.8544C4.9628 6.73352 4.80178 6.67125 4.59634 6.66758H3.83287V7.92308Z"
    fill="white"
  />
  <path
    d="M6.67018 10V6H7.91394C8.26929 6 8.58671 6.07967 8.86619 6.23901C9.14751 6.39652 9.36683 6.62179 9.52415 6.91484C9.68147 7.20604 9.76013 7.53755 9.76013 7.90934V8.09341C9.76013 8.4652 9.6824 8.79579 9.52693 9.08517C9.37331 9.37454 9.15584 9.5989 8.87451 9.75824C8.59319 9.91758 8.27577 9.99817 7.92227 10H6.67018ZM7.50305 6.66758V9.33791H7.90561C8.23135 9.33791 8.48029 9.2326 8.65242 9.02198C8.82454 8.81136 8.91246 8.51007 8.91616 8.11813V7.90659C8.91616 7.5 8.83102 7.19231 8.66074 6.98352C8.49047 6.77289 8.24153 6.66758 7.91394 6.66758H7.50305Z"
    fill="white"
  />
  <path
    d="M12.8001 8.36538H11.201V10H10.3681V6H13V6.66758H11.201V7.70055H12.8001V8.36538Z"
    fill="white"
  />
</template>
